function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M204 19.275v123.427a17.137 17.137 0 01-1.297 6.629 17.196 17.196 0 01-3.762 5.621 17.29 17.29 0 01-5.647 3.749 17.37 17.37 0 01-6.663 1.299H62.49a17.37 17.37 0 01-6.663-1.299 17.29 17.29 0 01-5.647-3.749 17.201 17.201 0 01-3.762-5.621 17.13 17.13 0 01-1.297-6.629v-41.946c0-.479-.137-.948-.397-1.352a2.514 2.514 0 00-1.067-.924L4 81l39.657-17.525a2.467 2.467 0 001.075-.92c.26-.404.395-.876.39-1.356V19.275a17.104 17.104 0 011.297-6.625 17.178 17.178 0 013.762-5.617 17.284 17.284 0 015.648-3.742A17.358 17.358 0 0162.489 2h124.142a17.353 17.353 0 016.661 1.29 17.291 17.291 0 015.648 3.742 17.17 17.17 0 013.762 5.617A17.098 17.098 0 01204 19.275v0z",
  stroke: "#1A1A1A",
  strokeWidth: 3,
  strokeMiterlimit: 10
});

function SvgDialoginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 206 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgDialoginline;